import { Platform } from "react-native";

let vars;
if (Platform.OS === 'web') {
    vars = {
        firebaseApiKey: 'AIzaSyBjyQN8vfK6VKhkGfSZ01mgN3PUnzb6rew'
    };
} else if (Platform.OS === 'ios') {
    vars = {
        firebaseApiKey: 'AIzaSyAUc_NOSeLy32gircH_8r4MZfGEU9XmBhg'
    };
} else if (Platform.OS === 'android') {
    vars = {
        firebaseApiKey: 'AIzaSyDhoisJT4D9557ihtRJJ56pF_Hq1NCEaxw'
    };
};

export default vars;